<div class="flex h-screen w-full overflow-hidden bg-bg">
    <app-sidebar />
    <div class="flex-1 flex flex-col overflow-hidden min-w-0 w-full">
        <app-header />
        <main class="flex-1 overflow-x-hidden overflow-y-auto bg-bg p-4 pt-0 sm:p-6 sm:pt-0">
            <router-outlet />
        </main>
    </div>
</div>